<ng-template #middleFilter>
    <div class="flex gap-small align-items-center justify-content-center planned-work-date">
        <app-button
            icon="pi-chevron-left"
            [rounded]="true"
            [text]="true"
            [severity]="'secondary'"
            [disabled]="!canGoToPreviousDay()"
            [title]="prefix + 'previousDay' | translate"
            (clickEvent)="changeDay(-1)"
        ></app-button>

        <app-date-input
            [formField]="dateForm.date"
            [minDate]="today"
            [showButtonBar]="false"
        ></app-date-input>

        <app-button
            icon="pi-chevron-right"
            [rounded]="true"
            [text]="true"
            [severity]="'secondary'"
            [title]="prefix + 'nextDay' | translate"
            (clickEvent)="changeDay(1)"
        ></app-button>
    </div>
</ng-template>

<app-table
    tableKey="dashboardPlannedWork"
    [hideCheckboxes]="true"
    [columns]="columns()"
    [translatePrefix]="prefix"
    [showClearFilter]="false"
    [showFilters]="false"
    [showColumnVisiblity]="true"
    [showPagination]="false"
    [middleFilter]="middleFilter"
    [gridData]="store.data.filterCalendarItems()"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.filterCalendarItems"
    [refreshCallbackFragment]="plannedWorkFragment"
>
    <ng-template pTemplate="folders" let-data="data">
        <div class="flex flex-wrap gap-x-small">
            @for (item of data; track item.id) {
                @if (item.person) {
                    <app-user-chip
                        [user]="item.person"
                        [renderDetails]="true"
                        [renderType]="UserChipRenderTypeEnum.Client"
                    ></app-user-chip>
                }
            }
        </div>
    </ng-template>
</app-table>
